module.exports = __webpack_public_path__ + "img/2.f1cb2a9d.jpeg";